module.exports = __webpack_public_path__ + "static/media/donat.2bcd5e63.png";